export type BusinessUnit = {
    id: string;
    name: string;
    salesTaxPercentage: number;
    country: string;
};

class BusinessUnitsStore {
    businessUnits: BusinessUnit[] = [
        {
            id: 'EE7E4270-2972-E711-811E-E0071B67C991',
            name: 'NZ Rentals',
            salesTaxPercentage: 15,
            country: 'New Zealand',
        },
        {
            id: 'e10d8f7c-67e4-4bff-b23f-e86183653aa5',
            name: 'AU Rentals',
            salesTaxPercentage: 10,
            country: 'Australia',
        },
    ];

    getBusinessUnitById(id: string): BusinessUnit | undefined {
        return id ? this.businessUnits.find((bu) => bu.id.toLowerCase() === id.toLowerCase()) : undefined;
    }

    getBusinessUnitByCountry(country: string): BusinessUnit | undefined {
        return country ? this.businessUnits.find((bu) => bu.country.toLowerCase() === country.toLowerCase()) : undefined;
    }
}

const businessUnitsStore = new BusinessUnitsStore();
export default businessUnitsStore;
